module.exports = __webpack_public_path__ + "img/photo-6.9b118d73.webp";